import { IResponseBody, IUser } from '@interfaces';
import { IResponseCollection } from './user/structure/interfaces';

const date = new Date();

export const ROLES = {
  ADMIN: 'administrators',
  LEADER: 'leaders',
  ANALYST: 'analysts',
  CUSTOMER: 'customers',
};

export const REQUEST_TYPE = {
  RESET: 'reset_password',
  ACTIVATE: 'activate_user',
};

export const OS = {
  MAC: 'Mac',
  WINDOWS: 'Windows',
};

export const DEVICE = {
  IPAD: 'iPad',
  IPHONE: 'iPhone',
  UNKNOWN: 'Unknown',
};

export const COMPANY = 'companies';
export const GROUP = 'groups';
export const MODULE = 'modules';
export const UNFILTERED = 'unfiltered';
export const EMPTY = null;
export const UNDEFINED = 'undefined';
export enum MODULE_TAGS {
  TABLEAU = 'TABLEAU',
  ETL = 'ETL',
  ARCHIVOS = 'ARCHIVOS',
}

export const MAX_SIZE_LOGO_LENGTH = 2000;     // kb

export const TODAY = {
  start: () => {
    return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
  },
  end: () => {
    return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
  },
  // epoch: () => {
  //     startDateEpoch = new Date(startDate).getTime() / 1000;
  //     return this;
  // },
  // return obj;
};

export const enum OpenWorkbookAs {
  Report = 'Report',
  Image = 'Image'
}

export const EPOCH = (datetime: any) => {
  return new Date(datetime).getTime() / 1000;
};

const rgbToHex = (rgb) => {
  let hex = Number(rgb).toString(16);
  if (hex.length < 2) {
    hex = '0' + hex;
  }
  return hex;
};

// const hexToRgb = (hex) => {
//   const bigint = parseInt(hex, 16);
//   const r = (bigint >> 16) && 255;
//   const g = (bigint >> 8) && 255;
//   const b = bigint && 255;

//   return { r: r, g: g, b: b };
// };

const getRandomNumber = (min = 0, max = 255) => {
  let random = Math.random() * (max - min) + min;
  // let random = Math.floor(Math.random() * 256);
  random = Math.floor(random);
  return random;
};

export const COLORS = {
  GENERATE_COLOR: () => {
    const randomR = getRandomNumber(0, 180);
    const randomG = getRandomNumber(130, 255);
    const randomB = getRandomNumber(150, 255);
    return {
      r: randomR,
      g: randomG,
      b: randomG,
    };
  },
  FULL_COLOR_HEX: (rgbObject: object) => {
    const red = rgbToHex(rgbObject['r']);
    const green = rgbToHex(rgbObject['g']);
    const blue = rgbToHex(rgbObject['b']);
    return '#' + red + green + blue;
  },
};

export const getNumber = (strValue: any) => {
  let validNumber = 0;
  try {
    const str = String(strValue);
    validNumber = parseInt(str, 10);
  } catch (err) {
    console.log(err);
  }

  return validNumber;
};

export const loadInstanceOf = (id: number, collection: [], currentInstance: object) => {
  let instance = null;

  if (!isNaN(id)) {
    const validData = (collection !== EMPTY || collection.length);

    if (validData && currentInstance === EMPTY) {
      const auxInstance = collection.find(m => m['id'] === id);
      instance = (typeof auxInstance !== 'undefined') ? auxInstance : instance;
    }
  }

  return instance;
};

export const getReferencedValue = (ref: any, attr: string = null) => {
  // solo revisa el primer nivel del objeto
  const isObject = (attr !== null);
  const tempRef = ref;
  if (typeof ref !== 'undefined') {
    if (ref !== null) {
      if (isObject) {
        return (ref.hasOwnProperty(attr)) ? ref[attr] : null;
      }
      return ref;
    }
    return null;
  }
  return null;
};

export const assignObjectValues = (sourceObject: object, targetObject: object) => {
  const objectKeys = Object.keys(targetObject);
  objectKeys.map(k => targetObject[k] = sourceObject[k]);
  return Object.assign({}, targetObject);
};

export class ResponseBodyAdapter implements IResponseBody {
  private responseBody = {
    count: 0,
    next: null,
    previous: null,
    results: []
  };
  count = 0;
  next = null;
  previous = null;
  results = [] as [];
  subject: string = null;

  constructor(subject: string, response: IResponseBody = null) {
    this.count = (response !== null) ? response.count : 0;
    this.next = (response !== null) ? response.next : null;
    this.previous = (response !== null) ? response.previous : null;
    this.results = (response !== null) ? response.results : null;
    this.subject = subject;

    this.responseBody = Object.assign(
      this.responseBody,
      {count: this.count, next: this.next, previous: this.previous, results: []}
    );
  }

  getResponse(): IResponseCollection {
    const isUser = (
      this.subject === ROLES.ADMIN || this.subject === ROLES.LEADER ||
      this.subject === ROLES.ANALYST || this.subject === ROLES.CUSTOMER
    );

    if (isUser) {
      const users: IUser[] = (this.results === null) ? [] : this.results;
      this.responseBody.results = users;
      return this.responseBody;
    }

    return this.responseBody;
  }
}
